import React from "react";



const ChannelLabel = ({ channel }) => {
  // Normalize channel for comparison
  const isGreen = channel?.toLowerCase() === "greenfullfillment";

  // Select image based on channel
  const imgSrc = !channel
    ? "https://via.placeholder.com/53?text=No+Channel" // fallback image for empty/null
    : isGreen
    ? "https://www.greenfulfilment.co.uk/wp-content/uploads/2025/11/green-RGB-side-profile-copy-cropped-1.svg"
    : "https://via.placeholder.com/53?text=Other"; // another default image for other channels

  const style = {
    color: isGreen ? "green" : "black",
    fontWeight: isGreen ? "bold" : "normal",
  };

  return (
    <span style={style}>
      <img width="53px" src={imgSrc} alt={channel || "channel"} />
    </span>
  );
};

export default ChannelLabel;



